import AxiosAPI from '@qualitas/libs';
import { AxiosResponse } from 'axios';

export const SignatureAPI = (baseURL: string |undefined, clientId: string) => {
    const apiConfig = {
        baseURL,
        clientId,
        isApp: true,
        hasUnderMaintenance: false
    };
    const bookbuildingAPI = AxiosAPI({ ...apiConfig });

    const createSignature = (idContract: number) => {
        const serviceUrl = `/bookbuilding-api/Signature/CreateSignature?IdContract=${idContract}`;
        return bookbuildingAPI.post(serviceUrl)
    };

    const sendContract = (idContract: number) => {
        const serviceUrl = `/bookbuilding-api/Signature/SendContract?IdContract=${idContract}`;
        return bookbuildingAPI.post(serviceUrl)
    };

    const previewContract = (idContract: number, templateId?: number, shareTypeId?: number, shareTypeName?: string) => {
        const serviceUrl = `/bookbuilding-api/Signature/PreviewContract`;
        return bookbuildingAPI.get(serviceUrl, {
            params: { contractId: idContract, templateId, shareTypeId, shareTypeName },
            responseType: "blob"
        })
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const startPreviewContract = (idContract: number, templateId?: number, shareTypeId?: number, shareTypeName?: string) => {
        const serviceUrl = `/bookbuilding-api/Signature/StartPreviewContract`;
        return bookbuildingAPI.post(serviceUrl, null, {
            params: { contractId: idContract, templateId, shareTypeId, shareTypeName }
        })
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const getPreviewContractStatus = (jobId: string) => {
        const serviceUrl = `/bookbuilding-api/Signature/GetPreviewContractStatus`;
        return bookbuildingAPI.get(serviceUrl, {
            params: { jobId }
        })
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const downloadPreviewContract = (jobId: string, idContract: number, templateId?: number) => {
        const serviceUrl = `/bookbuilding-api/Signature/DownloadPreviewContract`;
        return bookbuildingAPI.get(serviceUrl, {
            params: { jobId, contractId: idContract, templateId },
            responseType: "blob"
        })
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const cancelContract = (idContract: string) => {
        const serviceUrl = `/bookbuilding-api/Signature/CancelContract?ContractId=${idContract}`;
        return bookbuildingAPI.put(serviceUrl)
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };
    
    return {
        createSignature,
        previewContract,
        startPreviewContract,
        getPreviewContractStatus,
        downloadPreviewContract,
        cancelContract,
		sendContract
    };
};
